export default __webpack_public_path__ + "static/media/authy.ac3382de.svg";